function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "4B8H";


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive ^\.\/favicon.(png|jpe?g|svg|ico)$
// module id = 4B8H
// module chunks = 1